import { c as _slicedToArray, e as _taggedTemplateLiteral, f as _asyncToGenerator, _ as _objectSpread2 } from './_rollupPluginBabelHelpers-fb970440.js';
import React, { useState, useEffect, useContext } from 'react';
import { useHistory, Link } from 'react-router-dom';
import { useQuantaFormikContext, QuantaForm, QuantaInput, Button, Text, NotificationList, QuantaFormik, Checkbox, QuantaButton, Footer } from 'quanta-ui';
import { faKey, faSpinner, faCheck, faUser, faLock, faRedo } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { u as useMutationQuery } from './useMutationQuery-42b53d8d.js';
import { gql, useMutation, useApolloClient } from '@apollo/client';
import { d as initCreateIntermediaryState, i as initIpaQuoteState } from './exports-166cdf01.js';
import 'crypto-js';
import { encrypt } from 'crypto-js/aes';
import { u as useFetchQuery } from './useFetchQuery-56ba5b94.js';
import { updateFieldUser, updateIntermediary, updateBusinessLocation, initIntermediaryState } from './common/intermediary/state.js';
import { O as OTPTimer } from './otp-timer-20405ccd.js';
import { Helmet } from 'react-helmet';
import { a as ConfigContext } from './ConfigProvider-9522944e.js';
import { i as initCreateCustState, h as initCreateCustMetaState } from './state-a4d3dd58.js';
import { initHealthPlansState, initHealthQuoteState } from './quote/health/state.js';
import { i as initSearchParamsState } from './state-0f17d715.js';
import { initBuyHealthPolicyVar } from './proposal/health/state.js';
import { initViewRenewPolicyVar } from './policy/renewal/health/state.js';
import { initViewRenewMotorPolicyVar } from './policy/renewal/motor/state.js';
import { initFireQuoteState } from './quote/fire/state.js';
import { initBuyMotorPolicyVar } from './proposal/motor/state.js';
import { i as initProfileDataState } from './ShortenString-21905b6b.js';
import { initShopSecureQuoteState } from './quote/shopsecure/state.js';
import './permissions.js';
import './state-92ba719e.js';
import './quote/motor/state.js';
import './state-1fb1e261.js';
import './quote/workmenscompensation/state.js';
import './state-cd3cac59.js';
import './state-74edd9f7.js';
import './state-f2888c41.js';
import './proposal/fire/state.js';
import './proposal/shopsecure/state.js';
import './state-1686d318.js';
import './loading-c16d3bd3.js';
import './queries-3df8abcc.js';
import './CurrencyFormater-d288bc4f.js';
import './useFetchCacheQuery-88ef52f3.js';
import './useCoversAndPlans-e373c56e.js';

var OTPTimers = function OTPTimers(_ref) {
  var duration = _ref.duration,
      setResendEnable = _ref.setResendEnable;

  var _useState = useState(duration),
      _useState2 = _slicedToArray(_useState, 2),
      timer = _useState2[0],
      setTimer = _useState2[1];

  useEffect(function () {
    var intervalId;

    var startTimer = function startTimer() {
      intervalId = setInterval(function () {
        setTimer(function (prevTimer) {
          if (prevTimer === 0) {
            // Timer reached zero, invoke the callback
            clearInterval(intervalId); // onTimeout();

            setResendEnable(true);
            return 0;
          }

          return prevTimer - 1;
        });
      }, 1000);
    };

    startTimer();
    return function () {
      return clearInterval(intervalId);
    };
  }, [duration]);
  return /*#__PURE__*/React.createElement("div", null, timer, " seconds left for Resend OTP button to enable");
};

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9;
gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  query allTypes{\n    userTypes {\n      typeName \n      category {\n        categoryName\n      }\n    }\n  }\n"])));
gql(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\nquery captacha($input: DomainInput) {\n  getDomainData(input: $input) {\n    code\n    value\n  }\n}\n"])));
var LOGIN_QUERY = gql(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  mutation doLogin($credentails: UserLoginInput!) {\n    doLogin(\n      credentails: $credentails\n    ) {\n      userId\n      userTypeName\n      authenticated\n      lastLogin\n      userProfileName\n      forcePasswordChange\n      profile {        \n        mobileNumber   \n      }\n      role {\n        roleName\n        roleCode\n        permissions {\n          resourcePermission\n        }\n        permissionType\n      }\n      organisation {\n        intermediaries {\n          intermediaryName\n          intermediaryCode\n          businessLocations{\n            code\n            name\n          }\n        }\n        associatedCoreEntity {\n          type\n          value\n        }\n      }\n    }\n  }\n"])));
gql(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  query myIntermediaries {\n    myIntermediaries {\n      intermediaryName\n      intermediaryCode\n      isSelected\n      businessLocations {\n        code\n        name\n      }\n    }\n  }\n"])));
var LOAD_USER_PROFILE = gql(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  query loadProfileData {\n    checkAuth {\n      userId\n      organisation {\n        associatedCoreEntity {\n          type\n          value\n        }\n      }\n    }\n  }\n"])));
var SEND_OTP = gql(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  mutation sendLoginOtp($userId: String!,$MFA: Boolean){\n    sendLoginOtp(userId:$userId, MFA:$MFA){\n      status\n      maskedMobile\n      mobile\n    }\n  }\n"])));
var GET_SELECTEDIMD_DTLS = gql(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  query selectedImdDtls {\n    selectedImdDtls {\n      intermediaryName\n      intermediaryCode\n      isSelected\n      businessLocations {\n        code\n        name\n      }\n    }\n  }\n"])));
var validate_OTP = gql(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  mutation validateOtp($userId: String, $otp: String,$type:String){\n    validateOtp(userId:$userId, otp:$otp, type:$type){\n      status\n    }\n  }\n"])));
var GET_MFA_LIMIT = gql(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  query MFAList{\n    MFAList{\n      code\n      value\n    }\n  }\n  "])));

var _require$1 = require('../../../intl/followupc'),
    getConfig$1 = _require$1.getConfig;
/** REACT_APP_AES_KEY - used same AES_KEY from auth, if any changes required set different key in both quanta-flows & advisor-auth */

var encryptData = function encryptData(data) {
  return encrypt(data, getConfig$1("REACT_APP_AES_KEY")).toString();
};

function MFA(props) {
  var _values$otp;

  props.isChecking;
      var setSendingOtp = props.setSendingOtp,
      sendingOTP = props.sendingOTP,
      errorMsg = props.errorMsg,
      setErrorMsg = props.setErrorMsg,
      successMsg = props.successMsg,
      setSuccessMsg = props.setSuccessMsg,
      useridd = props.useridd,
      setResendEnable = props.setResendEnable,
      resendEnable = props.resendEnable,
      setOtpSent = props.setOtpSent,
      isOtpSent = props.isOtpSent;
      props.setShowTransactionLockModal;
      props.doLoginData;
  var mutateQuery = useMutationQuery();

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2);
      _useState2[0];
      _useState2[1]; // const [sendingOTP, setSendingOtp] = useState(false);


  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2);
      _useState4[0];
      _useState4[1];

  var _useQuantaFormikConte = useQuantaFormikContext(),
      values = _useQuantaFormikConte.values,
      setFieldValue = _useQuantaFormikConte.setFieldValue;

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      validating = _useState6[0],
      setvalidating = _useState6[1];

  var _useState7 = useState(false),
      _useState8 = _slicedToArray(_useState7, 2),
      verify = _useState8[0],
      setVerify = _useState8[1];

  var _useState9 = useState([]),
      _useState10 = _slicedToArray(_useState9, 2),
      alerts = _useState10[0],
      setAlerts = _useState10[1];

  var clearAllMsg = function clearAllMsg() {
    setErrorMsg('');
    setSuccessMsg('');
    setAlerts([]);
  };

  var history = useHistory();
  useFetchQuery(); // console.log("valuesss",isOtpSent)

  var handleSendOtp = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(variables) {
      var sendOtpMutation, _yield$sendOtpMutatio, sendOtpData, _sendOtpData$sendLogi;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              clearAllMsg();
              _context.prev = 1;
              setSendingOtp(true);
              sendOtpMutation = mutateQuery({
                mutation: SEND_OTP,
                variables: {
                  userId: useridd === null || useridd === void 0 ? void 0 : useridd.userId,
                  MFA: true
                }
              });
              _context.next = 6;
              return sendOtpMutation;

            case 6:
              _yield$sendOtpMutatio = _context.sent;
              sendOtpData = _yield$sendOtpMutatio.data;

              // console.log('sendOtpData', sendOtpData.sendLoginOtp.status);
              if (sendOtpData.sendLoginOtp.status) {
                //  console.log("inside if sendOtpData", sendOtpData);
                setOtpSent(true);
                setAlerts([{
                  header: 'OTP Details',
                  id: 1,
                  content: /*#__PURE__*/React.createElement("div", {
                    className: "flex flex-row flex-wrap space-y-2 w-full h-full"
                  }, "Otp Sent Successfully to registered mobile ".concat((_sendOtpData$sendLogi = sendOtpData.sendLoginOtp) === null || _sendOtpData$sendLogi === void 0 ? void 0 : _sendOtpData$sendLogi.mobile.replace(/.(?=.{3})/g, 'x'))),
                  type: 'success',
                  timeout: 20000,
                  disableClose: false
                }]);
              } else {
                setAlerts([{
                  header: 'OTP Details',
                  id: Date.now(),
                  content: /*#__PURE__*/React.createElement("div", {
                    className: "flex flex-row flex-wrap space-y-2 w-full h-full"
                  }, " Failed to send OTP "),
                  type: 'error',
                  timeout: 10000,
                  disableClose: false
                }]);
              }

              _context.next = 14;
              break;

            case 11:
              _context.prev = 11;
              _context.t0 = _context["catch"](1);
              setAlerts([{
                header: 'OTP Details',
                id: Date.now(),
                content: /*#__PURE__*/React.createElement("div", {
                  className: "flex flex-row flex-wrap space-y-2 w-full h-full"
                }, " Failed to send OTP "),
                type: 'error',
                timeout: 10000,
                disableClose: false
              }]);

            case 14:
              setResendEnable(false);
              setSendingOtp(false);

            case 16:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 11]]);
    }));

    return function handleSendOtp(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  var handleSubmitOtp = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(values) {
      var sendOtpMutation, _yield$sendOtpMutatio2, validateOtp;

      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              clearAllMsg();
              _context2.prev = 1;
              setvalidating(true);
              sendOtpMutation = mutateQuery({
                mutation: validate_OTP,
                variables: {
                  otp: values === null || values === void 0 ? void 0 : values.otp,
                  userId: (values === null || values === void 0 ? void 0 : values.userId) || (useridd === null || useridd === void 0 ? void 0 : useridd.userId),
                  type: 'MFA'
                }
              });
              _context2.next = 6;
              return sendOtpMutation;

            case 6:
              _yield$sendOtpMutatio2 = _context2.sent;
              validateOtp = _yield$sendOtpMutatio2.data;

              // console.log('sendOtpData', sendOtpData);
              if (validateOtp.validateOtp.status) {
                setVerify(true);
                setvalidating(false); // console.log("inside if sendOtpData", validateOtp);

                setAlerts([{
                  header: 'OTP Details',
                  id: Date.now(),
                  content: /*#__PURE__*/React.createElement("div", {
                    className: "flex flex-row flex-wrap space-y-2 w-full h-full"
                  }, " OTP verified successfully "),
                  type: 'success',
                  timeout: 10000,
                  disableClose: false
                }]);
              } else {
                setvalidating(false);
                setVerify(false);
                setAlerts([{
                  header: 'OTP Details',
                  id: Date.now(),
                  content: /*#__PURE__*/React.createElement("div", {
                    className: "flex flex-row flex-wrap space-y-2 w-full h-full"
                  }, " OTP invalid or expired "),
                  type: 'error',
                  timeout: 10000,
                  disableClose: false
                }]);
              }

              _context2.next = 16;
              break;

            case 11:
              _context2.prev = 11;
              _context2.t0 = _context2["catch"](1);
              setvalidating(false);
              setVerify(false);
              setAlerts([{
                header: 'OTP Details',
                id: Date.now(),
                content: /*#__PURE__*/React.createElement("div", {
                  className: "flex flex-row flex-wrap space-y-2 w-full h-full"
                }, " OTP invalid or expired "),
                type: 'error',
                timeout: 10000,
                disableClose: false
              }]);

            case 16:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[1, 11]]);
    }));

    return function handleSubmitOtp(_x2) {
      return _ref2.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(QuantaForm, null, /*#__PURE__*/React.createElement("div", {
    className: "text-white text-center font-semibold text-xl align-middle mb-8",
    style: {
      backgroundColor: "#FF0000",
      height: "30px",
      borderRadius: "20px 20px 0px 0px"
    }
  }, "OTP Verification"), /*#__PURE__*/React.createElement("div", {
    className: " m-4 "
  }, /*#__PURE__*/React.createElement(QuantaInput, {
    label: "",
    name: "otp",
    size: "full",
    type: "text",
    placeholder: "Enter OTP",
    style: {
      padding: '15px'
    },
    iconPre: /*#__PURE__*/React.createElement(FontAwesomeIcon, {
      icon: faKey,
      spin: false
    }),
    autocomplete: "off"
  })), /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-row items-center justify-center gap-4"
  }, /*#__PURE__*/React.createElement(Button, {
    size: "medium",
    type: "submit",
    disabled: sendingOTP || validating || (values === null || values === void 0 ? void 0 : (_values$otp = values.otp) === null || _values$otp === void 0 ? void 0 : _values$otp.length) < 6,
    onClick: function onClick() {
      // setFieldValue('password', '')
      handleSubmitOtp(values);
    },
    iconPre: validating ? /*#__PURE__*/React.createElement(FontAwesomeIcon, {
      icon: faSpinner,
      spin: true
    }) : verify ? /*#__PURE__*/React.createElement(FontAwesomeIcon, {
      icon: faCheck,
      spin: false
    }) : ''
  }, verify ? 'Verified' : 'Verify OTP'), /*#__PURE__*/React.createElement(Button, {
    size: "medium",
    type: "button",
    flat: true,
    disabled: !resendEnable || verify,
    onClick: function onClick() {
      setFieldValue('otp', '');
      handleSendOtp(values.userId);
    },
    iconPre: sendingOTP ? /*#__PURE__*/React.createElement(FontAwesomeIcon, {
      icon: faSpinner,
      spin: true
    }) : ''
  }, sendingOTP ? 'Sending OTP' : 'Resend OTP'))), /*#__PURE__*/React.createElement("div", {
    className: "mt-4"
  }, !resendEnable && isOtpSent && /*#__PURE__*/React.createElement(OTPTimers, {
    duration: 60,
    setResendEnable: setResendEnable
  })), /*#__PURE__*/React.createElement("div", {
    className: "mt-16"
  }, /*#__PURE__*/React.createElement(Button, {
    size: "full",
    type: "button",
    disabled: sendingOTP || !verify,
    onClick: function onClick() {
      if (verify) {
        history.push('/home'); // if(doLoginData?.doLogin?.alreadyLogged?.toString() === 'false'){
        //   history.push('/home');
        // }
        // else{
        //   setShowTransactionLockModal(true);
        // }
        // history.push('/home');
      } else {
        setAlerts([{
          header: '',
          id: Date.now(),
          content: /*#__PURE__*/React.createElement("div", {
            className: "flex flex-row flex-wrap space-y-2 w-full h-full"
          }, "Please verify OTP before proceeding "),
          type: 'error',
          timeout: 10000,
          disableClose: false
        }]);
      }
    } // disabled={isChecking
    //     || (captachavisible && !isVerified) ||
    //     !values.password}
    // iconPre={
    //     isChecking ? (
    //         <FontAwesomeIcon icon={faSpinner} spin={true} />
    //     ) : (
    //         <FontAwesomeIcon icon={faKey} />
    //     )
    // }

  }, "Login")), /*#__PURE__*/React.createElement(Text, {
    severity: "error",
    type: "label"
  }, errorMsg), /*#__PURE__*/React.createElement(Text, {
    severity: "success",
    type: "label"
  }, successMsg), /*#__PURE__*/React.createElement(NotificationList, {
    items: alerts
  }), /*#__PURE__*/React.createElement("br", null)));
}

var _require = require('../../../intl/followupc'),
    getConfig = _require.getConfig; // const { getConfig } = require('../../../lib/intl/followupc');  // Quanta-flows


function LoginForm() {
  var _document$getElements, _document$getElements2;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isChecking = _useState2[0],
      setChecking = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      resendEnable = _useState4[0],
      setResendEnable = _useState4[1];

  var _useState5 = useState(''),
      _useState6 = _slicedToArray(_useState5, 2),
      errorMsg = _useState6[0],
      setErrorMsg = _useState6[1];

  var _useState7 = useState(''),
      _useState8 = _slicedToArray(_useState7, 2),
      successMsg = _useState8[0],
      setSuccessMsg = _useState8[1];

  var _useState9 = useState(false),
      _useState10 = _slicedToArray(_useState9, 2),
      mfaAccess = _useState10[0],
      setmfaAccess = _useState10[1];

  var _useState11 = useState(''),
      _useState12 = _slicedToArray(_useState11, 2),
      useridd = _useState12[0],
      setuseridd = _useState12[1];

  var _useState13 = useState(''),
      _useState14 = _slicedToArray(_useState13, 2);
      _useState14[0];
      _useState14[1];

  var _useState15 = useState(false),
      _useState16 = _slicedToArray(_useState15, 2),
      isOtpSent = _useState16[0],
      setOtpSent = _useState16[1];

  var _useState17 = useState(false),
      _useState18 = _slicedToArray(_useState17, 2),
      sendingOTP = _useState18[0],
      setSendingOtp = _useState18[1];

  var _useState19 = useState(false),
      _useState20 = _slicedToArray(_useState19, 2),
      askToken = _useState20[0];
      _useState20[1];

  var _useState21 = useState(false),
      _useState22 = _slicedToArray(_useState21, 2),
      setCaptcha = _useState22[1];

  var _useState23 = useState(false),
      _useState24 = _slicedToArray(_useState23, 2),
      askOtp = _useState24[0],
      setAskOtp = _useState24[1];

  var _useState25 = useState(false),
      _useState26 = _slicedToArray(_useState25, 2);
      _useState26[0];
      _useState26[1];

  var _useState27 = useState(null),
      _useState28 = _slicedToArray(_useState27, 2),
      userTypeSelected = _useState28[0];
      _useState28[1];

  var _useState29 = useState(false),
      _useState30 = _slicedToArray(_useState29, 2);
      _useState30[0];
      var setLoadingIntermediaries = _useState30[1];

  var _useState31 = useState(false),
      _useState32 = _slicedToArray(_useState31, 2);
      _useState32[0];
      var setLoadingProfileData = _useState32[1];

  var _useState33 = useState(null),
      _useState34 = _slicedToArray(_useState33, 2);
      _useState34[0];
      var setErrorIntermediaries = _useState34[1];

  var history = useHistory();
  var fetchQuery = useFetchQuery();
  var mutateQuery = useMutationQuery();

  var _useState35 = useState(''),
      _useState36 = _slicedToArray(_useState35, 2),
      variablesData = _useState36[0],
      setVariablesData = _useState36[1];

  var _useState37 = useState(''),
      _useState38 = _slicedToArray(_useState37, 2),
      loginData = _useState38[0];
      _useState38[1]; // const { loading, error, data } = useQuery(ALL_TYPES, {
  //   fetchPolicy: 'cache-first',
  //   onCompleted: (data) => {
  //     setUserTypeSelected(data?.userTypes[0]);
  //   },
  // });

  /** SU Divya: VAPT- cannot Proceed without token - moving the flag to env "REACT_APP_CATACHA_VISIBLE=Y/N"
  const { loading: loadingcaptachaquery,
    error: errorcaptachaquery,
    data: captachaquerydata, } = useQuery(CAPTACHA_QUERY, {
      fetchPolicy: 'network-only',
      variables: {
        input: {
          domainType: 'CAPTCHA_TYPE',
        },
      },
      onCompleted: (data) => {
        if (data?.getDomainData?.[0]?.value?.toLowerCase() === 'yes') {
          setCaptchavisible(true)
        }
      },
    });
  EU Divya:  VAPT */


  var _useState39 = useState([]),
      _useState40 = _slicedToArray(_useState39, 2),
      alerts = _useState40[0],
      setAlerts = _useState40[1];

  var clearAllMsg = function clearAllMsg() {
    setErrorMsg('');
    setSuccessMsg('');
    setAlerts([]);
  };

  var captcha = function captcha() {
    var allowedChars = "1,2,3,4,5,6,7,8,9,A,B,C,D,E,F,G,H,J,K,L,M,N,P,Q,R,S,T,U,V,W,X,Y,Z,a,b,c,d,e,f,g,h,i,j,k,l,m,n,o,p,q,r,s,t,u,v,w,x,y,z";
    var arr = allowedChars.split(',');
    var strCaptcha = "";

    for (var i = 0; i < 4; i++) {
      var n = Math.floor(Math.random() * (arr.length - 1) + 1);
      strCaptcha += arr[n];
    }

    return strCaptcha;
  };

  var strCaptcha = isChecking === true ? (_document$getElements = document.getElementsByName('txtcaptcha')) === null || _document$getElements === void 0 ? void 0 : (_document$getElements2 = _document$getElements[0]) === null || _document$getElements2 === void 0 ? void 0 : _document$getElements2.innerText : captcha();

  var _useMutation = useMutation(LOGIN_QUERY, {
    onCompleted: function () {
      var _onCompleted = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(data) {
        var _sessionStorage, _data$doLogin, _data$doLogin$role, _data$doLogin2, _data$doLogin2$profil, _mfaOtpData$MFAList, _mfaOtpData$MFAList$v, mfaQuery, _yield$mfaQuery, mfaOtpData, _dataMyIntermediaries, _selectedIntermediary, _selectedIntermediary2, _sessionStorage2, _sessionStorage3, _sessionStorage4, _selectedIntermediary3, _sessionStorage5, _selectedIntermediary4, _userTypeSelected$toS, _userTypeSelected$toS2, fetchIntermediaries, _yield$fetchIntermedi, dataMyIntermediaries, selectedIntermediary, _profileData$checkAut, _profileData$checkAut2, _profileData$checkAut3, _profileData$checkAut4, _profileData$checkAut5, _profileData$checkAut6, _sessionStorage6, _profileData$checkAut7, _profileData$checkAut8, _profileData$checkAut9, _sessionStorage7, _profileData$checkAut10, _profileData$checkAut11, _profileData$checkAut12, profileDataQuery, _yield$profileDataQue, profileData, _sessionStorage8, _sessionStorage9;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                setChecking(false);

                if (!data.doLogin.authenticated) {
                  _context.next = 56;
                  break;
                }

                mfaQuery = fetchQuery({
                  query: GET_MFA_LIMIT
                });
                _context.next = 5;
                return mfaQuery;

              case 5:
                _yield$mfaQuery = _context.sent;
                mfaOtpData = _yield$mfaQuery.data;
                (_sessionStorage = sessionStorage) === null || _sessionStorage === void 0 ? void 0 : _sessionStorage.setItem('roleName', data === null || data === void 0 ? void 0 : (_data$doLogin = data.doLogin) === null || _data$doLogin === void 0 ? void 0 : (_data$doLogin$role = _data$doLogin.role) === null || _data$doLogin$role === void 0 ? void 0 : _data$doLogin$role.roleName); // console.log("roleName: ",variablesData);

                if (!(data !== null && data !== void 0 && (_data$doLogin2 = data.doLogin) !== null && _data$doLogin2 !== void 0 && (_data$doLogin2$profil = _data$doLogin2.profile) !== null && _data$doLogin2$profil !== void 0 && _data$doLogin2$profil.mobileNumber && (variablesData === null || variablesData === void 0 ? void 0 : variablesData.otp) == '' && (mfaOtpData === null || mfaOtpData === void 0 ? void 0 : (_mfaOtpData$MFAList = mfaOtpData.MFAList) === null || _mfaOtpData$MFAList === void 0 ? void 0 : (_mfaOtpData$MFAList$v = _mfaOtpData$MFAList.value) === null || _mfaOtpData$MFAList$v === void 0 ? void 0 : _mfaOtpData$MFAList$v.toLowerCase()) == 'yes')) {
                  _context.next = 13;
                  break;
                }

                setmfaAccess(true);
                handleSendOtpp(variablesData, true);
                _context.next = 54;
                break;

              case 13:
                if (!data.doLogin.forcePasswordChange) {
                  _context.next = 17;
                  break;
                }

                history.push('/security/password/forcechange');
                _context.next = 54;
                break;

              case 17:
                _context.prev = 17;

                /*GET_INTERMEDIARY_LIST --> GET_SELECTEDIMD_DTLS - Loading Issue after Login */
                fetchIntermediaries = fetchQuery({
                  query: GET_SELECTEDIMD_DTLS //GET_INTERMEDIARY_LIST,

                });
                setLoadingIntermediaries(true);
                _context.next = 22;
                return fetchIntermediaries;

              case 22:
                _yield$fetchIntermedi = _context.sent;
                dataMyIntermediaries = _yield$fetchIntermedi.data;
                setLoadingIntermediaries(false);
                selectedIntermediary = dataMyIntermediaries === null || dataMyIntermediaries === void 0 ? void 0 : (_dataMyIntermediaries = dataMyIntermediaries.selectedImdDtls) === null || _dataMyIntermediaries === void 0 ? void 0 : _dataMyIntermediaries.find(function (intermediary) {
                  return intermediary === null || intermediary === void 0 ? void 0 : intermediary.isSelected;
                });
                updateIntermediary(selectedIntermediary === null || selectedIntermediary === void 0 ? void 0 : selectedIntermediary.intermediaryCode, selectedIntermediary === null || selectedIntermediary === void 0 ? void 0 : selectedIntermediary.intermediaryName);
                updateBusinessLocation(selectedIntermediary === null || selectedIntermediary === void 0 ? void 0 : (_selectedIntermediary = selectedIntermediary.businessLocations[0]) === null || _selectedIntermediary === void 0 ? void 0 : _selectedIntermediary.code, selectedIntermediary === null || selectedIntermediary === void 0 ? void 0 : (_selectedIntermediary2 = selectedIntermediary.businessLocations[0]) === null || _selectedIntermediary2 === void 0 ? void 0 : _selectedIntermediary2.name);
                (_sessionStorage2 = sessionStorage) === null || _sessionStorage2 === void 0 ? void 0 : _sessionStorage2.setItem('intermediaryCode', selectedIntermediary === null || selectedIntermediary === void 0 ? void 0 : selectedIntermediary.intermediaryCode);
                (_sessionStorage3 = sessionStorage) === null || _sessionStorage3 === void 0 ? void 0 : _sessionStorage3.setItem('intermediaryName', selectedIntermediary === null || selectedIntermediary === void 0 ? void 0 : selectedIntermediary.intermediaryName);
                (_sessionStorage4 = sessionStorage) === null || _sessionStorage4 === void 0 ? void 0 : _sessionStorage4.setItem('branchOfficeCode', selectedIntermediary === null || selectedIntermediary === void 0 ? void 0 : (_selectedIntermediary3 = selectedIntermediary.businessLocations[0]) === null || _selectedIntermediary3 === void 0 ? void 0 : _selectedIntermediary3.code);
                (_sessionStorage5 = sessionStorage) === null || _sessionStorage5 === void 0 ? void 0 : _sessionStorage5.setItem('branchOfficeName', selectedIntermediary === null || selectedIntermediary === void 0 ? void 0 : (_selectedIntermediary4 = selectedIntermediary.businessLocations[0]) === null || _selectedIntermediary4 === void 0 ? void 0 : _selectedIntermediary4.name);

                if (!((userTypeSelected === null || userTypeSelected === void 0 ? void 0 : (_userTypeSelected$toS = userTypeSelected.toString()) === null || _userTypeSelected$toS === void 0 ? void 0 : (_userTypeSelected$toS2 = _userTypeSelected$toS.trim()) === null || _userTypeSelected$toS2 === void 0 ? void 0 : _userTypeSelected$toS2.toLowerCase()) === 'field user')) {
                  _context.next = 45;
                  break;
                }

                profileDataQuery = fetchQuery({
                  query: LOAD_USER_PROFILE
                });
                setLoadingProfileData(true);
                _context.next = 37;
                return profileDataQuery;

              case 37:
                _yield$profileDataQue = _context.sent;
                profileData = _yield$profileDataQue.data;
                updateFieldUser(profileData === null || profileData === void 0 ? void 0 : (_profileData$checkAut = profileData.checkAuth) === null || _profileData$checkAut === void 0 ? void 0 : (_profileData$checkAut2 = _profileData$checkAut.organisation) === null || _profileData$checkAut2 === void 0 ? void 0 : (_profileData$checkAut3 = _profileData$checkAut2.associatedCoreEntity) === null || _profileData$checkAut3 === void 0 ? void 0 : _profileData$checkAut3.type, profileData === null || profileData === void 0 ? void 0 : (_profileData$checkAut4 = profileData.checkAuth) === null || _profileData$checkAut4 === void 0 ? void 0 : (_profileData$checkAut5 = _profileData$checkAut4.organisation) === null || _profileData$checkAut5 === void 0 ? void 0 : (_profileData$checkAut6 = _profileData$checkAut5.associatedCoreEntity) === null || _profileData$checkAut6 === void 0 ? void 0 : _profileData$checkAut6.value);
                (_sessionStorage6 = sessionStorage) === null || _sessionStorage6 === void 0 ? void 0 : _sessionStorage6.setItem('fieldUserCode', profileData === null || profileData === void 0 ? void 0 : (_profileData$checkAut7 = profileData.checkAuth) === null || _profileData$checkAut7 === void 0 ? void 0 : (_profileData$checkAut8 = _profileData$checkAut7.organisation) === null || _profileData$checkAut8 === void 0 ? void 0 : (_profileData$checkAut9 = _profileData$checkAut8.associatedCoreEntity) === null || _profileData$checkAut9 === void 0 ? void 0 : _profileData$checkAut9.type);
                (_sessionStorage7 = sessionStorage) === null || _sessionStorage7 === void 0 ? void 0 : _sessionStorage7.setItem('fieldUserName', profileData === null || profileData === void 0 ? void 0 : (_profileData$checkAut10 = profileData.checkAuth) === null || _profileData$checkAut10 === void 0 ? void 0 : (_profileData$checkAut11 = _profileData$checkAut10.organisation) === null || _profileData$checkAut11 === void 0 ? void 0 : (_profileData$checkAut12 = _profileData$checkAut11.associatedCoreEntity) === null || _profileData$checkAut12 === void 0 ? void 0 : _profileData$checkAut12.value);
                setLoadingProfileData(false);
                _context.next = 48;
                break;

              case 45:
                updateFieldUser('', '');
                (_sessionStorage8 = sessionStorage) === null || _sessionStorage8 === void 0 ? void 0 : _sessionStorage8.setItem('fieldUserCode', '');
                (_sessionStorage9 = sessionStorage) === null || _sessionStorage9 === void 0 ? void 0 : _sessionStorage9.setItem('fieldUserName', '');

              case 48:
                // history.push('/quote/select/product');
                history.push('/home');
                _context.next = 54;
                break;

              case 51:
                _context.prev = 51;
                _context.t0 = _context["catch"](17);
                setErrorIntermediaries(_context.t0 === null || _context.t0 === void 0 ? void 0 : _context.t0.message);

              case 54:
                _context.next = 57;
                break;

              case 56:
                setErrorMsg('* Invalid User Type or User ID or Password');

              case 57:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[17, 51]]);
      }));

      function onCompleted(_x) {
        return _onCompleted.apply(this, arguments);
      }

      return onCompleted;
    }(),
    onError: function onError(error) {
      setChecking(false);
      setErrorMsg("* ".concat(error.message)); //setErrorMsg('* Invalid User Type or User Id or Password');
    }
  }),
      _useMutation2 = _slicedToArray(_useMutation, 1),
      doLogin = _useMutation2[0];

  var _useMutation3 = useMutation(SEND_OTP, {
    onCompleted: function onCompleted(data) {
      setSendingOtp(false);

      if (data.sendLoginOtp.status) {
        setOtpSent(true);
        setAlerts([{
          header: 'OTP Details',
          id: 1,
          content: /*#__PURE__*/React.createElement("div", {
            className: "flex flex-row flex-wrap space-y-2 w-full h-full"
          }, "Otp Send Successfully to registered mobile ".concat(data.sendLoginOtp.maskedMobile)),
          type: 'success',
          timeout: 10000,
          disableClose: false
        }]);
      } else {
        setErrorMsg('* Failed to Send OTP');
      }

      setResendEnable(false);
    },
    onError: function onError(error) {
      setOtpSent(false);
      setSendingOtp(false);
      setResendEnable(false);
      setErrorMsg("* ".concat(error.message));
    }
  }),
      _useMutation4 = _slicedToArray(_useMutation3, 1),
      sendOtp = _useMutation4[0]; // if (loading || loadingIntermediaries || loadingProfileData || loadingcaptachaquery)
  //   return <Loading />;
  // if (error || errorIntermediaries || errorcaptachaquery) return <Error />;
  // const { userTypes } = data;
  // const allTypes = userTypes.map((typ) => typ.typeName);


  var initialValues = {
    categoryName: '',
    userType: '',
    //allTypes && allTypes?.length > 0 ? allTypes[0] : '',
    userId: '',
    password: '',
    mfaToken: '',
    otp: '',
    captacha: ''
  };

  var validate = function validate(values) {
    var _document, _document$getElements3, _document$getElements4;

    var tcaptcha = (_document = document) === null || _document === void 0 ? void 0 : (_document$getElements3 = _document.getElementsByName('txtcaptcha')) === null || _document$getElements3 === void 0 ? void 0 : (_document$getElements4 = _document$getElements3[0]) === null || _document$getElements4 === void 0 ? void 0 : _document$getElements4.innerText;
    var errors = {}; // if (!values.userType) {
    //   errors.userType = '* Required';
    // } else 

    if (!values.userId) {
      errors.userId = '* Required';
    } else if (!values.captacha && getConfig("REACT_APP_CATACHA_VISIBLE") === "Y" //captachavisible
    ) {
        errors.captacha = '* Required';
      } else if (!(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.userId) || /^[A-Z0-9]*$/i.test(values.userId))) {
      errors.userId = '* Invalid email address';
    } else if (!askToken && !askOtp && !values.password) {
      errors.password = '* Required';
    } else if (askToken && !values.mfaToken) {
      errors.mfaToken = '* Required';
    } else if (askToken && !/^[0-9]{6}$/i.test(values.mfaToken)) {
      errors.mfaToken = '* Should be a 4 digit number';
    } else if ((values.captacha !== tcaptcha || values.captacha.length < 4) && getConfig("REACT_APP_CATACHA_VISIBLE") === "Y" //captachavisible
    ) {
        errors.captacha = '* captcha does not match';
      } else if (askOtp && !/^[0-9]{6}$/i.test(values.otp)) {
      errors.otp = '* Should be a 6 digit number';
    }

    return errors;
  };

  var onSubmit = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(variables, _ref) {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              clearAllMsg();
              setChecking(true); // console.log("beforeelse",variables)

              if (/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(variables.userId) && variables.userId !== 'patel.ajay@Kotak.com') {
                // console.log("inside if")
                variables.userType = 'Intermediary'; //  variables.userType='Field User'

                variables.categoryName = 'External';
              } else {
                variables.userType = 'Internal User';
                variables.categoryName = 'Internal';
              }

              if (variables.userId === 'patel.ajay@Kotak.com') {
                variables.userType = 'Internal User';
                variables.categoryName = 'Internal';
              }

              setVariablesData(variables);
              _context2.next = 8;
              return doLogin({
                variables: {
                  credentails: _objectSpread2(_objectSpread2({}, variables), {}, {
                    categoryName: variables.categoryName,
                    password: encryptData(variables.password) //  userTypes.find(
                    //   (typ) => typ.typeName === variables.userType,
                    // ).category.categoryName,

                  })
                }
              });

            case 8:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function onSubmit(_x2, _x3) {
      return _ref2.apply(this, arguments);
    };
  }();

  var handleSendOtp = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(userId) {
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              clearAllMsg();

              if (!(userId && /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(userId) || /^[A-Z0-9]*$/i.test(userId))) {
                _context3.next = 7;
                break;
              }

              setSendingOtp(true);
              _context3.next = 5;
              return sendOtp({
                variables: {
                  userId: userId
                }
              });

            case 5:
              _context3.next = 8;
              break;

            case 7:
              setErrorMsg('* Valid UserId is required');

            case 8:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function handleSendOtp(_x4) {
      return _ref3.apply(this, arguments);
    };
  }();

  var handleSendOtpp = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(variables, mfaAccess) {
      var sendOtpMutation, _yield$sendOtpMutatio, sendOtpData, _sendOtpData$sendLogi;

      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              clearAllMsg();
              _context4.prev = 1;
              setSendingOtp(true);
              sendOtpMutation = mutateQuery({
                mutation: SEND_OTP,
                variables: {
                  userId: variables === null || variables === void 0 ? void 0 : variables.userId,
                  MFA: mfaAccess
                }
              });
              _context4.next = 6;
              return sendOtpMutation;

            case 6:
              _yield$sendOtpMutatio = _context4.sent;
              sendOtpData = _yield$sendOtpMutatio.data;
              // console.log('sendOtpData', sendOtpData);
              setuseridd(variables);

              if (sendOtpData.sendLoginOtp.status) {
                setOtpSent(true);
                setAlerts([{
                  header: 'OTP Details',
                  id: 1,
                  content: /*#__PURE__*/React.createElement("div", {
                    className: "flex flex-row flex-wrap space-y-2 w-full h-full"
                  }, "Otp Sent Successfully to registered mobile ".concat((_sendOtpData$sendLogi = sendOtpData.sendLoginOtp) === null || _sendOtpData$sendLogi === void 0 ? void 0 : _sendOtpData$sendLogi.mobile.replace(/.(?=.{3})/g, 'x'))),
                  type: 'success',
                  timeout: 10000,
                  disableClose: false
                }]);
              } else {
                setAlerts([{
                  header: 'OTP Details',
                  id: Date.now(),
                  content: /*#__PURE__*/React.createElement("div", {
                    className: "flex flex-row flex-wrap space-y-2 w-full h-full"
                  }, " Failed to send OTP "),
                  type: 'error',
                  timeout: 10000,
                  disableClose: false
                }]);
              }

              _context4.next = 15;
              break;

            case 12:
              _context4.prev = 12;
              _context4.t0 = _context4["catch"](1);
              setErrorMsg(_context4.t0.errorMsg);

            case 15:
              setResendEnable(false);
              setSendingOtp(false);

            case 17:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, null, [[1, 12]]);
    }));

    return function handleSendOtpp(_x5, _x6) {
      return _ref4.apply(this, arguments);
    };
  }();

  var OtpForm = function OtpForm() {
    var _useQuantaFormikConte = useQuantaFormikContext(),
        values = _useQuantaFormikConte.values,
        setFieldValue = _useQuantaFormikConte.setFieldValue;

    return /*#__PURE__*/React.createElement(QuantaForm, null, /*#__PURE__*/React.createElement("div", {
      className: "text-white text-center font-semibold text-2xl align-middle",
      style: {
        backgroundColor: "#FF0000",
        height: "30px",
        borderRadius: "20px 20px 0px 0px"
      }
    }, "Log In"), /*#__PURE__*/React.createElement("div", {
      className: "m-3"
    }, /*#__PURE__*/React.createElement(QuantaInput, {
      label: "User ID",
      name: "userId",
      size: "full",
      type: "text",
      placeholder: "Enter User ID",
      iconPre: /*#__PURE__*/React.createElement(FontAwesomeIcon, {
        icon: faUser,
        spin: false
      }),
      disabled: isChecking || isOtpSent
    }), askOtp ? /*#__PURE__*/React.createElement(QuantaInput, {
      label: "OTP",
      name: "otp",
      size: "full",
      type: "text",
      placeholder: "Enter OTP",
      iconPre: /*#__PURE__*/React.createElement(FontAwesomeIcon, {
        icon: faLock,
        spin: false
      }),
      disabled: isChecking || !isOtpSent
    }) : /*#__PURE__*/React.createElement(QuantaInput, {
      label: "Password",
      name: "password",
      size: "full",
      type: "password",
      placeholder: "Enter Password",
      iconPre: /*#__PURE__*/React.createElement(FontAwesomeIcon, {
        icon: faLock,
        spin: false
      }),
      disabled: isChecking,
      style: {
        padding: "15px"
      },
      autocomplete: "off"
    }), /*#__PURE__*/React.createElement("div", {
      className: "flex flex-col space-y-2 items-center justify-between"
    }, /*#__PURE__*/React.createElement("span", {
      className: "w-full"
    }, /*#__PURE__*/React.createElement(Checkbox, {
      checked: askOtp,
      onChange: setAskOtp,
      label: "Use One Time Passsword(OTP)"
    })), /*#__PURE__*/React.createElement("span", {
      className: "w-full"
    }, !askOtp ? /*#__PURE__*/React.createElement(Link, {
      to: '/security/password/reset',
      className: "quanta_link  text-md"
    }, "Forgot Your Password ?") : /*#__PURE__*/React.createElement(Link, {
      className: "quanta_link  text-sm",
      to: '',
      hidden: !isOtpSent || !resendEnable,
      onClick: function onClick() {
        handleSendOtp(values.userId);
      }
    }, "Resend OTP"))), /*#__PURE__*/React.createElement("div", {
      onContextMenu: function onContextMenu(e) {
        return e.preventDefault();
      }
    }, getConfig("REACT_APP_CATACHA_VISIBLE") === "Y" //captachavisible 
    &&
    /*#__PURE__*/
    React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "lbcaptcha",
      style: {
        display: "flex",
        flexwrap: "wrap",
        padding: "0.3rem",
        alignItems: "center",
        letterSpacing: "0.3rem",
        userSelect: "none",
        justifyContent: "space-between"
      }
    }, /*#__PURE__*/React.createElement(Text, {
      id: "lb",
      type: "label",
      name: "txtcaptcha",
      className: "w-40 ",
      style: {
        backgroundColor: "#ccc3c3",
        margin: "0.2rem",
        padding: "0.2rem 1.5rem",
        fontSize: "2.5rem",
        Color: "#ffffff"
      }
    }, strCaptcha), /*#__PURE__*/React.createElement(QuantaButton, {
      onClick: setCaptcha,
      type: "button",
      className: "w-15 h-18"
    }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
      icon: faRedo
    }))), /*#__PURE__*/React.createElement(QuantaInput, {
      name: "captacha",
      size: "full",
      type: "text",
      placeholder: "Enter captacha",
      style: {
        padding: "15px"
      }
    }))), askOtp ? isOtpSent ? /*#__PURE__*/React.createElement(Button, {
      size: "full",
      type: "submit",
      disabled: isChecking || sendingOTP,
      iconPre: isChecking || sendingOTP ? /*#__PURE__*/React.createElement(FontAwesomeIcon, {
        icon: faSpinner,
        spin: true
      }) : /*#__PURE__*/React.createElement(FontAwesomeIcon, {
        icon: faKey
      })
    }, isChecking ? "Logging..." : "Login with OTP") : /*#__PURE__*/React.createElement(Button, {
      size: "full",
      type: "button",
      onClick: function onClick() {
        setFieldValue('password', '');
        handleSendOtp(values.userId);
      },
      iconPre: sendingOTP ? /*#__PURE__*/React.createElement(FontAwesomeIcon, {
        icon: faSpinner,
        spin: true
      }) : /*#__PURE__*/React.createElement(FontAwesomeIcon, {
        icon: faKey
      })
    }, "Send OTP") : /*#__PURE__*/React.createElement(Button, {
      size: "full",
      type: "submit",
      disabled: isChecking,
      iconPre: isChecking ? /*#__PURE__*/React.createElement(FontAwesomeIcon, {
        icon: faSpinner,
        spin: true
      }) : /*#__PURE__*/React.createElement(FontAwesomeIcon, {
        icon: faKey
      })
    }, isChecking ? "Logging..." : "Login with Password"), askOtp && isOtpSent && !resendEnable && /*#__PURE__*/React.createElement(OTPTimer, {
      duration: 50,
      setResendEnable: setResendEnable
    }), /*#__PURE__*/React.createElement(Text, {
      severity: "error",
      type: "label"
    }, errorMsg), /*#__PURE__*/React.createElement(Text, {
      severity: "success",
      type: "label"
    }, successMsg), /*#__PURE__*/React.createElement(NotificationList, {
      items: alerts
    }), /*#__PURE__*/React.createElement("br", null)));
  };

  var PassCodeForm = function PassCodeForm() {
    return /*#__PURE__*/React.createElement(QuantaForm, null, /*#__PURE__*/React.createElement("div", {
      className: "text-white text-center font-semibold text-2xl align-middle",
      style: {
        backgroundColor: "#FF0000",
        height: "30px",
        borderRadius: "20px 20px 0px 0px"
      }
    }, "Log In"), /*#__PURE__*/React.createElement("div", {
      className: "m-3"
    }, /*#__PURE__*/React.createElement(QuantaInput, {
      label: "User ID",
      name: "userId",
      size: "full",
      type: "text",
      placeholder: "Enter User ID",
      iconPre: /*#__PURE__*/React.createElement(FontAwesomeIcon, {
        icon: faUser,
        spin: false
      }),
      disabled: isChecking
    }), askToken ? /*#__PURE__*/React.createElement(QuantaInput, {
      label: "Passcode",
      name: "mfaToken",
      size: "full",
      type: "text",
      placeholder: "Enter 6 Digit Passcode",
      iconPre: /*#__PURE__*/React.createElement(FontAwesomeIcon, {
        icon: faLock,
        spin: false
      }),
      disabled: isChecking
    }) : /*#__PURE__*/React.createElement(QuantaInput, {
      label: "Password",
      name: "password",
      size: "full",
      type: "password",
      placeholder: "Enter Password",
      iconPre: /*#__PURE__*/React.createElement(FontAwesomeIcon, {
        icon: faLock,
        spin: false
      }),
      disabled: isChecking,
      style: {
        padding: "15px"
      },
      autocomplete: "off"
    }), /*#__PURE__*/React.createElement("div", {
      className: "flex flex-row items-center justify-between"
    }, /*#__PURE__*/React.createElement(Link, {
      to: '/security/password/reset',
      className: "quanta_link  text-sm"
    }, "Forgot Your Password ?")), /*#__PURE__*/React.createElement("div", {
      onContextMenu: function onContextMenu(e) {
        return e.preventDefault();
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "lbcaptcha",
      style: {
        display: "flex",
        flexwrap: "wrap",
        padding: "0.3rem",
        alignItems: "center",
        letterSpacing: "0.3rem",
        userSelect: "none",
        justifyContent: "space-between"
      }
    }, /*#__PURE__*/React.createElement(Text, {
      id: "lb",
      type: "label",
      name: "txtcaptcha",
      className: "w-40 ",
      style: {
        backgroundColor: "#ccc3c3",
        margin: "0.2rem",
        padding: "0.2rem 1.5rem",
        fontSize: "2.5rem",
        Color: "#ffffff"
      }
    }, strCaptcha), /*#__PURE__*/React.createElement(QuantaButton, {
      onClick: setCaptcha,
      type: "button",
      className: "w-15 h-18"
    }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
      icon: faRedo
    }))), /*#__PURE__*/React.createElement(QuantaInput, {
      name: "captacha",
      size: "full",
      type: "text",
      placeholder: "Enter captacha",
      style: {
        padding: "15px"
      }
    })), askToken ? /*#__PURE__*/React.createElement(Button, {
      size: "full",
      type: "submit",
      disabled: isChecking,
      iconPre: isChecking ? /*#__PURE__*/React.createElement(FontAwesomeIcon, {
        icon: faSpinner,
        spin: true
      }) : /*#__PURE__*/React.createElement(FontAwesomeIcon, {
        icon: faKey
      })
    }, isChecking ? "Logging..." : "Login with Passcode") : /*#__PURE__*/React.createElement(Button, {
      size: "full",
      type: "submit",
      disabled: isChecking,
      iconPre: isChecking ? /*#__PURE__*/React.createElement(FontAwesomeIcon, {
        icon: faSpinner,
        spin: true
      }) : /*#__PURE__*/React.createElement(FontAwesomeIcon, {
        icon: faKey
      })
    }, isChecking ? "Logging..." : "Login with Password"), /*#__PURE__*/React.createElement(Text, {
      severity: "error",
      type: "label"
    }, errorMsg), /*#__PURE__*/React.createElement("br", null)));
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("style", null, "\n        .separator {\n          display: flex;\n          align-items: center;\n          text-align: center;\n        }\n        \n        .separator::before,\n        .separator::after {\n          content: \"\";\n          flex: 1;\n          border-bottom: 2px solid;\n        }\n        \n        .separator::before {\n          margin-right: 0.25em;\n        }\n        \n        .separator::after {\n          margin-left: 0.25em;\n        }    \n        .Captacha{\n          backgroundColor:#ccc3c3;\n          height:30px;\n          padding-right:10px;\n           fontSize:30px,\n           Color:#ffffff;\n        }        \n      "), /*#__PURE__*/React.createElement(QuantaFormik, {
    initialValues: initialValues,
    validate: validate,
    onSubmit: onSubmit
  }, /*#__PURE__*/React.createElement(React.Fragment, null, !mfaAccess && (process.env.REACT_APP_ALT_LOGIN === 'OTP' ? /*#__PURE__*/React.createElement(OtpForm, null) : /*#__PURE__*/React.createElement(PassCodeForm, null)), mfaAccess && /*#__PURE__*/React.createElement(MFA, {
    isChecking: isChecking,
    sendingOTP: sendingOTP,
    setSendingOtp: setSendingOtp,
    errorMsg: errorMsg,
    setErrorMsg: setErrorMsg,
    successMsg: successMsg,
    setSuccessMsg: setSuccessMsg,
    useridd: useridd,
    setResendEnable: setResendEnable,
    resendEnable: resendEnable,
    setOtpSent: setOtpSent,
    isOtpSent: isOtpSent,
    doLoginData: loginData
  }))), /*#__PURE__*/React.createElement(NotificationList, {
    items: alerts
  }));
}

var resetAllReactiveVars = function resetAllReactiveVars() {
  initCreateCustState();
  initCreateIntermediaryState();
  initHealthPlansState();
  initHealthQuoteState();
  initSearchParamsState();
  initBuyHealthPolicyVar();
  initHealthPlansState();
  initCreateCustMetaState();
  initViewRenewPolicyVar();
  initIntermediaryState();
  initViewRenewMotorPolicyVar();
  initFireQuoteState();
  initIpaQuoteState();
  initBuyMotorPolicyVar();
  initProfileDataState();
  initShopSecureQuoteState();
};

function LoginPage(props) {
  var _useContext = useContext(ConfigContext);
      _useContext.branding;
      var menu = _useContext.menu;

  var client = useApolloClient();
  useEffect(function () {
    var refetchQueries = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return client.clearStore().then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                  return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          _context.next = 2;
                          return client.resetStore();

                        case 2:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee);
                })));

              case 2:
                return _context2.abrupt("return", _context2.sent);

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function refetchQueries() {
        return _ref2.apply(this, arguments);
      };
    }();

    resetAllReactiveVars();
    refetchQueries();
  });
  return /*#__PURE__*/React.createElement("div", {
    className: "bg-white dark:bg-white-700 "
  }, /*#__PURE__*/React.createElement(Helmet, null, /*#__PURE__*/React.createElement("title", null, "Zurich Kotak General Insurance")), /*#__PURE__*/React.createElement("div", {
    className: "logo "
  }, /*#__PURE__*/React.createElement("img", {
    src: "paceimages/alpha-logo-ori.jpg",
    class: "h-16 w-full object-cover object-left",
    loading: "lazy"
  })), /*#__PURE__*/React.createElement("div", {
    className: "w-full flex flex-wrap justify-center items-center relative overflow-hidden bg-red-50"
  }, /*#__PURE__*/React.createElement("div", {
    className: "hidden md:flex lg:flex xl:flex absolute",
    style: {
      backgroundImage: "url(\"images/login-illustration.jpg\")",
      width: '100vw',
      height: '100vh',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'cover'
    }
  }, "  "), /*#__PURE__*/React.createElement("div", {
    class: "relative bg-white w-96 max-w-lg my-14  md:mr-10  xl:mr-10 lg:mr-10 sm:max-w-lg sm:mx-auto ",
    style: {
      borderRadius: "20px"
    }
  }, /*#__PURE__*/React.createElement(LoginForm, null))), /*#__PURE__*/React.createElement("div", {
    className: "relative"
  }, /*#__PURE__*/React.createElement(Footer, {
    data: menu.footer
  }), " "));
}

export default LoginPage;
